var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyVideoCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video classes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 163",
    filter: "url(#filter0_b_338_2860)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 4,
    fill: "url(#paint0_linear_338_2860)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.705 10.6876C14.7051 10.6876 14.7051 10.6876 14.7051 10.6876C15.2576 10.2987 15.7844 9.92857 16.31 9.55727C16.5466 9.39094 16.7866 9.22696 17.0199 9.05595C17.848 8.44686 18.8346 9.01612 19.0277 9.94498C19.0456 10.0328 19.0567 10.1242 19.0567 10.2132C19.0589 11.784 19.0601 13.3535 19.0567 14.9243C19.0545 15.6962 18.4272 16.3521 17.7163 16.3345C17.4696 16.3287 17.2475 16.242 17.0433 16.0979C16.3067 15.5779 15.5701 15.059 14.8323 14.5401C14.8293 14.5379 14.8262 14.5358 14.8231 14.5337C14.7753 14.5007 14.7051 14.5324 14.7051 14.5904C14.7051 14.9852 14.7062 15.3799 14.7051 15.7746C14.7006 16.529 14.127 17.1357 13.4093 17.1369C11.3691 17.1392 9.33002 17.1392 7.28981 17.1369C6.5811 17.1369 6.00297 16.5266 6.00185 15.7817C5.99962 13.6393 5.99962 11.4982 6.00073 9.35698C6.00185 8.61202 6.57998 8.00176 7.2887 8.00176C9.33337 7.99941 11.3769 7.99941 13.4216 8.00176C14.1225 8.00176 14.6995 8.61202 14.704 9.34878C14.7073 9.78519 14.704 10.2216 14.704 10.6872C14.704 10.6878 14.7047 10.688 14.705 10.6876ZM10.3669 8.91304C9.37355 8.91304 8.38135 8.91304 7.38803 8.91304C7.04093 8.91304 6.87016 9.09226 6.87016 9.45654C6.87016 11.5321 6.87016 13.6065 6.87016 15.6821C6.87016 16.0464 7.04093 16.2256 7.38691 16.2256C9.3635 16.2256 11.3401 16.2256 13.3178 16.2256C13.666 16.2256 13.8357 16.0476 13.8357 15.6821C13.8357 13.6065 13.8357 11.5321 13.8357 9.45654C13.8357 9.09226 13.6649 8.91304 13.3178 8.91304C12.3334 8.91304 11.3501 8.91304 10.3657 8.91304H10.3669ZM18.189 12.5676C18.1886 12.5676 18.1884 12.5673 18.1884 12.567C18.1884 12.0108 18.1884 11.4546 18.1884 10.8984C18.1884 10.6841 18.1929 10.4697 18.1862 10.2566C18.1795 10.0434 18.0913 9.87001 17.9083 9.76694C17.7754 9.69197 17.6471 9.72126 17.5254 9.80676C16.6125 10.451 15.6984 11.094 14.7877 11.7406C14.7475 11.7687 14.7096 11.8355 14.7096 11.8847C14.704 12.3415 14.704 12.7983 14.7096 13.254C14.7096 13.3008 14.743 13.3617 14.7788 13.3898C14.9283 13.5046 15.0857 13.6089 15.2397 13.7178C15.9986 14.2531 16.7576 14.7884 17.5176 15.3225C17.7275 15.4701 17.9328 15.4432 18.069 15.2194C18.1382 15.1058 18.1828 14.9559 18.1839 14.8224C18.1951 14.0717 18.1895 13.3199 18.1895 12.5681C18.1895 12.5678 18.1893 12.5676 18.189 12.5676Z",
    fill: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_338_2860",
    x: -30,
    y: -30,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_338_2860"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_338_2860",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_338_2860",
    x1: 1.66667,
    y1: 1.66667,
    x2: 37.5293,
    y2: 47.1633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVideoCourses);
export default __webpack_public_path__ + "static/media/MyVideoCourses.1abc5eaeda66b07a56f853c8da210016.svg";
export { ForwardRef as ReactComponent };